export enum ConsentPlatform {
  /**
   * @deprecated Use PATIENT_APP instead
   */
  APP = 'APP',
  PORTAL = 'PORTAL',
  PATIENT_WEB = 'PATIENT_WEB',
  PATIENT_APP = 'PATIENT_APP',
}

export type ConsentPlatformKey = keyof typeof ConsentPlatform;
